window.jRespond = window.jRespond || require('jRespond');
var Homepage = {};

(function ($) {
    'use strict';

    Homepage = function () {

        var self = {}, __self = {};

        self.init = function () {

            // DOM Elements
            __self.$body = $('body');
            __self.$app = $('#app');
            __self.$header = $('.site-header.-home');
            __self.$bulletinItemText = $('.homepage-grid .bulletin-item .-text');

            // Measurements
            __self.$winHeight;
            __self.$winWidth;

            // jRespond Settings
            __self.jRes = jRespond([
            {
                label: 'mobile',
                enter: 0,
                exit: 999
            },{
                label: 'desktop',
                enter: 1000,
                exit: 10000
            }
            ]);

            // jRespond Behavior
            __self.jRes.addFunc([
            {
                breakpoint: ['mobile'],
                enter: function() {
                    __self.breakpoint = 'mobile';
                },
                exit: function() {

                }
            },
            {
                breakpoint: ['desktop'],
                enter: function() {
                    __self.breakpoint = 'desktop';
                },
                exit: function() {
                }
            }
            ]);

            // Module Init
            self.homepageInit();
        };

        self.homepageInit = function () {

            self.getMeasurements();
            self.setHeight();
            self.bulletinVerticalAlign();

        };

        self.getMeasurements = function() {
            __self.$winWidth = $(window).width();
            __self.$winHeight = $(window).height();
        };

        self.setHeight = function() {
            __self.$header.css('height', __self.$winHeight);
        };

        self.bulletinVerticalAlign = function() {

            __self.$bulletinItemText.each(function() {
                if(__self.breakpoint === 'desktop') {
                    $(this).css('margin-top', '-' + (($(this).height())/2) + 'px');
                } else {
                    $(this).css('margin-top', 0); 
                }
            });
            
        }

        self.resize = function() {
            self.getMeasurements();
            self.setHeight();
            self.bulletinVerticalAlign();
        };

        self.init();
        return self;
    };

}(window.jQuery));

module.exports = Homepage;
